import appGlobalScript from '/home/runner/work/covet-pics-widget/covet-pics-widget/src/global/app.ts';
export const globalScripts = appGlobalScript;
